import { useEffect, useRef, useState } from 'react';
import { useBetSlip } from './BetSlipContext';

export default function MobileBetSlipButton() {
  const { items, toggleSlip } = useBetSlip();
  const prevCountRef = useRef(items.length);
  const [animKey, setAnimKey] = useState(0);

  useEffect(() => {
    if (items.length > prevCountRef.current) {
      setAnimKey(k => k + 1);
    }
    prevCountRef.current = items.length;
  }, [items.length]);

  if (items.length === 0) return null;

  const totalShares = items.reduce((acc, item) => acc + item.qty, 0);

  return (
    <>
      <style>{`
        @keyframes badgePop {
          0%   { transform: scale(1); }
          25%  { transform: scale(1.45); }
          50%  { transform: scale(0.88); }
          70%  { transform: scale(1.18); }
          85%  { transform: scale(0.96); }
          100% { transform: scale(1); }
        }
        .badge-pop {
          animation: badgePop 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
        }
      `}</style>

      <button
        onClick={toggleSlip}
        className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] md:hidden flex items-center gap-2.5 px-5 py-3 rounded-full shadow-xl shadow-teal-500/25 transition-all active:scale-95 cursor-pointer"
        style={{
          background: 'linear-gradient(135deg, #14b8a6 0%, #10b981 100%)',
        }}
      >
        {/* Icon */}
        <div className="w-8 h-8 flex items-center justify-center rounded-full bg-slate-900/20">
          <i className="ri-file-list-3-line text-slate-900 text-base"></i>
        </div>

        {/* Text */}
        <span className="text-slate-900 font-bold text-sm whitespace-nowrap">
          Bet Slip
        </span>

        {/* Badge with count */}
        <div className="flex items-center gap-1.5 pl-2 border-l border-slate-900/20">
          <span className="text-xs text-slate-800 font-semibold">
            {items.length} bet{items.length !== 1 ? 's' : ''}
          </span>
          <span
            key={animKey}
            className={`flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full bg-slate-900 text-teal-400 text-xs font-bold${animKey > 0 ? ' badge-pop' : ''}`}
          >
            {totalShares}
          </span>
        </div>
      </button>
    </>
  );
}
